import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontBrandModuleTypes from '@/store/modules/frontDesk/brand/interface';

const frontBrandModule: Module<FrontBrandModuleTypes, RootModuleTypes> = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    listBrandCategory(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listBrandCategory', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listCompanyBrand(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listCompanyBrand', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    pageCompanyBrandList(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/pageCompanyBrandList', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listActivityTag(context, params) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/activity/anon/listActivityTag', params)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listCompanyArea(context, params) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listCompanyArea', params)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    
  },
};

export default frontBrandModule;
